// import EditParty from '../../components/PartyInfo/EditParty'
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";

const EditCustomerComponent = loadable(
  () => import("../../components/Customer/CustomerEdit")
);
const EditCustomer = () => {
  const { id } = useParams();

  const { data, isLoading: isDataLoading } = useGetHook({
    url: `${APIS.USER}${id}`,
    queryKey: ["party-info", `party-info-${id}`],
    params: {},
  });

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["party-info"],
    navigateURL: "/accounting/customer",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.USER}${id}/`;
    const formData = {
      ...values,
      is_supplier: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Edit Customer</h1>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditCustomerComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          data={data}
        />
      )}
    </div>
  );
};

export default EditCustomer;

